function media() {
	const dynamicElements = document.querySelectorAll('.wp-block-media-text');

	dynamicElements.forEach(element => {
		const computedStyle = getComputedStyle(element);
		const backgroundColor = computedStyle.backgroundColor;

		element.style.setProperty('--dynamic-base-color', backgroundColor);
		element.style.setProperty('background-color', 'transparent', 'important');
	});
}

export {media};